import {utils} from 'payment-widget-core'

/**
 * Renders the `formInfo` block of a form slice as e.g. "15 000 ₽".
 * Both parts can be missing while /form/init is still in flight, so each is
 * dropped independently rather than printing "undefined".
 */
export function formatAmount(formInfo) {
  const symbol = formInfo?.currency ? utils.getCurrencySymbol(formInfo.currency) : ''
  return [formInfo?.amountFormatted, symbol].filter(Boolean).join(' ')
}
